module.exports = __webpack_public_path__ + "assets/img/img239.69ce51a5.png";